"use strict";

function SilkRibbon(params) {
  var quantity = parseInt(params.ribbonSpool_quantity, 10);
  var ribbon_spool_color = params.ribbon_color;
  this.ribbonSpools.add({
    quantity: quantity,
    ribbon_spool_color: ribbon_spool_color
  });
}

module.exports = SilkRibbon;